import { buildScopedI18n } from '../../utils/buildScopedI18n';
import flagEsCL from './locales/es-CL.json';
import flagEnUS from './locales/en-US.json';
import flagPtBR from './locales/pt-BR.json';

export const escriturasFlagsI18n = buildScopedI18n({
  esCL: flagEsCL,
  enUS: flagEnUS,
  ptBR: flagPtBR,
});
